import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigation = [
    { name: 'Início', href: '#hero' },
    { name: 'Contato', href: '#cta' }
  ];

  const whatsappNumber = '5521965983038';
  const whatsappMessage = 'Olá, vim pelo Google e quero mais informações para fazer parte do time de Traders.';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <header className="dark-header">
      <div className="dark-header-content">
        {/* Logo */}
        <div className="dark-logo-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_pips-recruit/artifacts/gsidg3r5_WhatsApp%20Image%202026-01-19%20at%2017.04.44.jpeg"
            alt="Sofia Investe" 
            className="dark-logo sofia-avatar"
          />
          <span className="logo-text">Sofia Investe</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="dark-nav">
          {navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="dark-nav-link"
            >
              {item.name}
            </a>
          ))}
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Começar Agora
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-nav">
          {navigation.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.name}
            </a>
          ))}
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary mobile-cta"
            onClick={() => setMobileMenuOpen(false)}
          >
            Começar Agora
          </a>
        </div>
      )}
    </header>
  );
};
